import { useState } from 'react';
import { showErrorToast } from '../../../../src/utilities/notificationUtils';

type RiskAssessmentStep = 'initialStep' | 'formOpen' | 'resultOpen';

const useRiskAssessmentStep = () => {
  const [step, setStep] = useState<RiskAssessmentStep>('initialStep');

  const onTriggerClicked = () => setStep('formOpen');

  const onSubmitClicked = form => {
    const isIncomplete = form?.fields.some(field => field.answer === undefined) ?? false;
    if (isIncomplete) {
      showErrorToast('Please complete the assessment questions.');
    } else {
      setStep('resultOpen');
    }
  };

  const onClose = () => {
    setStep('initialStep');
  };
  return { step, onTriggerClicked, onSubmitClicked, onClose };
};

export default useRiskAssessmentStep;
